/**
 * Nav icon for the Classification view. A tag glyph — the view assigns
 * subjective category "terms" to technologies and applications. Feather-style
 * stroke geometry with stroke="currentColor" so it inherits the rail's
 * active/inactive color (conventions/frontend-stack.md: Icon Usage).
 */
function ClassificationIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
      <line x1="7" y1="7" x2="7.01" y2="7" />
    </svg>
  );
}

export default ClassificationIcon;
